module.exports = __webpack_public_path__ + "img/footer_logo.2d6ff70c.png";